<template>
  <div>
    <div class="card">
      <div>
        <div class="content">
          <div class="card-header ps-7 pe-5">
            <h3 class="card-title align-items-start flex-column">
              <span class="card-label fw-bolder mb-1">{{ translate("ActivitiyTypeAdd_3") }}</span>

              <span class="text-muted mt-1 fw-bold fs-7">{{ records }} {{ translate("Records_Found") }}</span>
            </h3>
          </div>
        </div>
      </div>
      <div
        class="modal fade"
        tabindex="-1"
        id="add-operation-modal"
        ref="newTargetModalRef"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered mw-950px">
          <div class="modal-content rounded">
            <BlockUI :loading="block" />
            <div class="modal-header">
              <h5 class="modal-title">{{ translate(title) }}</h5>

              <!--begin::Close-->
              <div
                class="btn btn-icon btn-sm btn-active-light-primary ms-2 text-dark"
                @click="modalClose"
                aria-label="Close"
              >
                <i class="bi bi-x-lg"></i>
              </div>
              <!--end::Close-->
            </div>

            <div
              class="modal-body rounded p-0"
              style="padding-bottom: 1.5rem !important; background: #fbfbfb"
            >
              <Form
                v-slot="{ errors }"
                ref="refForm"
                id="example"
                class="form"
                novalidate="novalidate"
                @submit="saveData"
                :validation-schema="operationValidator"
                style="padding-bottom: 1.5rem !important; background: #fbfbfb"
              >
                <div>
                  <div
                    v-if="contentLanguages.length > 0"
                    class="card-header card-header-stretch"
                  >
                    <div class="card-toolbar">
                      <ul
                        class="nav nav-tabs nav-line-tabs nav-stretch fs-5 border-0 text-nowrap flex-nowrap mw-850px"
                        style="overflow-x: auto; overflow-y: hidden"
                      >
                        <li class="nav-item mx-3">
                          <a
                            @click="activeLink = 'Standart'"
                            class="nav-link fs-6"
                            :class="`${activeLink === 'Standart' ? 'active langue-tabs-bold' : ''}`"
                            data-bs-toggle="tab"
                            href="#kt_tab_pane_1"
                            >{{ translate("ActivitiyTypeAdd_2") }}</a
                          >
                        </li>
                        <li
                          v-for="(item, index) in contentLanguages"
                          :key="index"
                          class="nav-item mx-3"
                        >
                          <a
                            @click="activeLink = item.Value"
                            :class="`nav-link fs-6 ${activeLink === item.Value ? 'active langue-tabs-bold' : ''}`"
                            data-bs-toggle="tab"
                            :href="`#${item.Value}`"
                            >{{ item.Value }}</a
                          >
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="card-body">
                    <div
                      class="tab-content"
                      id="myTabContent"
                    >
                      <div
                        class="tab-pane fade show active"
                        id="kt_tab_pane_1"
                        role="tabpanel"
                      >
                        <div class="row">
                          <label class="col-lg-4 col-form-label required fw-bold fs-6">{{
                            translate("ActivitiyTypeAdd_4")
                          }}</label>
                          <div class="col-lg-8 fv-row d-v-container">
                            <div class="fv-plugins-message-container d-v-content">
                              <div class="fv-help-block ms-2 v-element">
                                <ErrorMessage name="name" />
                              </div>
                            </div>
                            <Field
                              type="text"
                              name="name"
                              :class="`form-control form-control-lg fs-6 ${
                                errors['name'] !== undefined ? 'v-invalid' : ''
                              }`"
                              :placeholder="translate('ActivitiyTypeAdd_4')"
                              v-model.trim="operationType.name"
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        v-for="(item, index) in contentLanguages"
                        :key="index"
                        class="tab-pane fade"
                        :id="`${item.Value}`"
                        role="tabpanel"
                      >
                        <div class="row">
                          <label class="col-lg-4 col-form-label fw-bold fs-6">{{
                            translate("ActivitiyTypeAdd_4")
                          }}</label>
                          <div class="col-lg-8 fv-row">
                            <input
                              type="text"
                              :id="`name-${item.Id}`"
                              :name="item.Id"
                              class="form-control form-control-lg fs-6"
                              :placeholder="translate('ActivitiyTypeAdd_4')"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex justify-content-end pb-7 pe-10">
                    <a
                      class="btn btn-white btn-active-light me-2 btn-sm fs-6 border"
                      @click="modalClose"
                    >
                      {{ translate("Cancel") }}
                    </a>
                    <button
                      v-show="addUp"
                      type="submit"
                      class="btn btn-primary btn-sm fs-6 border"
                    >
                      <div
                        v-if="loadingButton"
                        class="spinner-border spinner-border-sm mx-1"
                      ></div>
                      <span class="indicator-label">
                        {{ translate("Add") }}
                      </span>
                    </button>
                    <a
                      v-show="!addUp"
                      :class="`btn btn-primary border btn-sm fs-6 ${
                        Object.keys(errors).length > 0 || loadingButton ? 'disabled' : ''
                      }`"
                      @click="updateData"
                    >
                      <div
                        v-if="loadingButton"
                        class="spinner-border spinner-border-sm mx-1"
                      ></div>
                      <span class="indicator-label">
                        {{ translate("Save") }}
                      </span>
                    </a>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div class="p-5">
          <div class="card-toolbar mb-5">
            <div class="d-flex justify-content-end align-items-center">
              <button
                type="button"
                class="btn btn-primary btn-sm"
                data-bs-toggle="modal"
                data-bs-target="#add-operation-modal"
              >
                {{ translate("ActivitiyTypeNew") }}
              </button>
              <button
                v-if="selectedActivity.length > 0"
                @click="deleteSelectedActiviy($event)"
                type="button"
                class="btn bg-light bg-hover-secondary btn-sm border position-relative ms-2"
              >
                {{ translate("Delete_Select")
                }}<span class="position-absolute top-0 start-100 translate-middle badge badge-circle badge-danger">{{
                  selectedActivity.length
                }}</span>
              </button>
            </div>
          </div>

          <div>
            <DataTable
              :value="activititype"
              :lazy="true"
              :paginator="false"
              removableSort
              dataKey="Id"
              @sort="onSort($event)"
              :loading="loading"
              v-model:selection="selectedActivity"
              :selectAll="selectAll"
              @select-all-change="onSelectAllChange"
              v-model:filters="filters"
              :totalRecords="totalRecords"
              @filter="onFilter($event)"
              filterDisplay="row"
              :globalFilterFields="['name']"
              responsiveLayout="scroll"
              @row-select="onRowSelect"
              @row-unselect="onRowUnselect"
              class="rounded"
            >
              <Column
                selectionMode="multiple"
                headerStyle="width: 3em"
              ></Column>
              <Column
                field="Name"
                :header="translate('ActivitiyTypeAdd_5')"
                filterField="Name"
                filterMatchMode="contains"
                ref="Name"
                style="width: 18rem !important; min-width: 18rem !important"
                :sortable="true"
              >
                <template #filter="{ filterModel, filterCallback }">
                  <InputText
                    v-model="filterModel.value"
                    type="text"
                    @keydown.enter="filterCallback()"
                    class="p-column-filter"
                    :placeholder="translate('Search')"
                    @keyup="inputNull($event)"
                  />
                </template>
              </Column>

              <Column
                field="Id"
                :rowEditor="true"
                bodyStyle="text-align:center"
                class="text-end"
                style="min-width: 12rem !important"
              >
                <template #body="{ data }">
                  <a
                    class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
                    :title="translate('Update')"
                    @click="getUpDateActivityType(data.Id)"
                    data-bs-toggle="modal"
                    data-bs-target="#add-operation-modal"
                  >
                    <span class="svg-icon svg-icon-3">
                      <inline-svg src="media/icons/duotune/art/art005.svg" />
                    </span>
                  </a>

                  <a
                    class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
                    :title="translate('Delete')"
                    @click="deleteSelectedActiviy($event, data)"
                  >
                    <span class="svg-icon svg-icon-3">
                      <inline-svg src="media/icons/duotune/general/gen027.svg" />
                    </span>
                  </a>
                </template>
              </Column>
            </DataTable>
            <ConfirmPopup></ConfirmPopup>
            <div class="mt-5">
              <Pagination
                @onPage="onPage"
                :TotalData="records"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { onMounted, computed, ref, reactive, watch } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import { hideModal } from "@/core/helpers/dom";
import * as Yup from "yup";
import { useConfirm } from "primevue/useconfirm";

const confirm = useConfirm();

const { t, te, locale } = useI18n();
const translate = (text) => {
  if (te(text)) {
    return t(text);
  } else {
    return text;
  }
};

// Validation Tanımlaması
const operationValidator = Yup.object().shape({
  name: Yup.string().nullable().required(translate("ActivitiyTypeAdd_Valid_Name")),
});

const store = useStore();

const newTargetModalRef = ref(null);
const refForm = ref(null);
const block = ref(false);
const loadingButton = ref(false);

// ! Content Languages
const modalClose = () => {
  hideModal(newTargetModalRef.value);
};
const clearForm = () => {
  setTimeout(() => {
    if (contentLanguages.value.length > 0) {
      contentLanguages.value.forEach((item) => {
        document.getElementById("name-" + item.Id).value = "";
      });
      contentLanguages.value.forEach((item) => {
        document.getElementById(item.Value).classList.remove("show", "active");
      });
      activeLink.value = "Standart";
      document.getElementById("kt_tab_pane_1").classList.add("show", "active");
    }
    operationType.Id = 0;
    operationType.name = null;
    operationType.locales = [];
    addUp.value = true;
    refForm.value.resetForm();
    title.value = "ActivitiyTypeAddTitle";
  }, 300);
};

store.dispatch("LanguageModule/GET_LOCALİZATON");
const contentLanguages = computed(() => store.getters["LanguageModule/_getLocalizatonList"]);
const activeLink = ref("Standart");
const operationType = reactive({
  Id: 0,
  name: null,
  locales: [],
});
const addUp = ref(true);
const title = ref("ActivitiyTypeAddTitle");

// ! Save Data
const saveData = () => {
  loadingButton.value = true;
  if (contentLanguages.value.length > 0) {
    contentLanguages.value.forEach((item) => {
      var value = document.getElementById("name-" + item.Id).value;
      var localobj = {
        languageId: "",
        name: "",
      };
      if (value !== "") {
        localobj.languageId = item.Id;
        localobj.name = value;
        operationType.locales.push(localobj);
      }
    });
  }
  store.dispatch("ActivityTypeModule/ADD_ACTIVITY", operationType).then((response) => {
    loadingButton.value = false;
  });
  modalClose();
};

// ! Update Data
const updateData = () => {
  loadingButton.value = true;
  if (contentLanguages.value.length > 0) {
    contentLanguages.value.forEach((item) => {
      var value = document.getElementById("name-" + item.Id).value;
      if (value !== "") {
        var localobj = {
          languageId: "",
          name: "",
        };
        localobj.languageId = item.Id;
        localobj.name = value;
        operationType.locales.push(localobj);
      }
    });
  }
  store.dispatch("ActivityTypeModule/UPDATE_ACTIVITY", operationType).then((response) => {
    loadingButton.value = false;
  });
  modalClose();
};

const getUpDateActivityType = (Id) => {
  block.value = true;
  title.value = "ActivitiyTypeUpdateTitle";
  addUp.value = false;
  store.dispatch("ActivityTypeModule/GET_ACTIVITY", Id).then((response) => {
    operationType.Id = response.Id;
    operationType.name = response.Name;
    response.Locales.forEach((item) => (document.getElementById("name-" + item.LanguageId).value = item.Name));
    block.value = false;
  });
};

const getData = (payLoad) => {
  store.dispatch("ActivityTypeModule/GET_ALL_ACTIVITY", payLoad);
};

const records = computed(() => store.getters["ActivityTypeModule/_getTotalRecords"]);
const activititype = computed(() => store.getters["ActivityTypeModule/_getActivity"]);
const loading = computed(() => store.getters["ActivityTypeModule/_getLoading"]);
let selectedActivity = ref([]);
const selectAll = ref(false);
const totalRecords = ref(0);
const lazyParams = ref({});

const filters = ref({
  Name: { value: "", matchMode: "contains" },
});

const onPage = (e) => {
  lazyParams.value.page = e.step.value;
  lazyParams.value.pageSize = e.pageSize.value;

  getData(lazyParams.value);
};

const onSort = (event) => {
  lazyParams.value.sortColumn = event.sortField;
  lazyParams.value.sortDirection = event.sortOrder === 1 ? "asc" : "desc";
  getData(lazyParams.value);
};
const onFilter = () => {
  lazyParams.value.name = filters.value.Name.value;
  getData(lazyParams.value);
};

const onSelectAllChange = (event) => {
  if (event.checked) {
    selectAll.value = true;
    selectedActivity.value = activititype.value;
  } else {
    selectAll.value = false;
    selectedActivity.value = [];
  }
};

const onRowSelect = () => {
  selectAll.value = selectedActivity.value.length === totalRecords.value;
};

const onRowUnselect = () => {
  selectAll.value = false;
};

const deleteSelectedActiviy = (event, Item) => {
  let obj = [];
  let list = [];
  if (Item !== undefined) {
    obj.push(Item.Id);
    list.push(obj);
    list.push(lazyParams.value);
  } else {
    selectedActivity.value.forEach((item) => {
      obj.push(item.Id);
    });
    list.push(obj);
    list.push(lazyParams.value);
  }
  let message = ref("");
  if (obj.length > 1) {
    message.value = translate("confirm_message_operations");
  } else {
    message.value = translate("confirm_message_operation");
  }

  confirm.require({
    target: event.currentTarget,
    message: message,
    icon: "pi pi-exclamation-triangle",
    acceptLabel: translate("customer_location_confirm_acceptLabel"),
    rejectLabel: translate("customer_location_confirm_rejectLabel"),
    acceptClass: "btn btn-sm btn-primary",
    rejectClass: "btn btn-sm btn-light",
    accept: () => {
      store.dispatch("ActivityTypeModule/DELETE_ACTIVITY", list).finally((selectedActivity.value = []));
    },
    reject: () => {
      return;
    },
  });
};

const inputNull = (event) => {
  if (event.target.value === "") {
    lazyParams.value.name = "";
    getData(lazyParams.value);
  }
};

watch(locale, () => {
  setCurrentPageBreadcrumbs(translate("ActivitiyTypeAdd_Business_Activity_Type_Page"), [translate("Customers")]);
});

onMounted(() => {
  lazyParams.value = {
    page: 1,
    pageSize: 10,
    sortColumn: null,
    sortDirection: null,
    name: "",
  };
  setCurrentPageBreadcrumbs(translate("ActivitiyTypeAdd_Business_Activity_Type_Page"), [translate("Customers")]);

  getData({ page: 1, pageSize: 10 });

  document.getElementById("add-operation-modal").addEventListener("hide.bs.modal", function () {
    clearForm();
  });
});
</script>

<style scoped></style>
